import React from "react"
import { DeepReadonly } from "ts-essentials"
import AnalyticsContext, { useAnalyticsWithProperties } from "connected-components/analytics/context"
import { useGraphAnalyticsProperties } from "./use-analytics-properties"

interface GraphAnalyticsProviderProps {
  children: React.ReactNode
}

export function GraphAnalyticsProvider({
  children,
}: DeepReadonly<GraphAnalyticsProviderProps>) {
  const contextProperties = useGraphAnalyticsProperties()

  const analyticsContextValue = useAnalyticsWithProperties(contextProperties, "Graph")

  return (
    <AnalyticsContext.Provider value={analyticsContextValue}>
      {children}
    </AnalyticsContext.Provider>
  )
}

export default GraphAnalyticsProvider
